import { render, staticRenderFns } from "./verificationProduct.vue?vue&type=template&id=404ad664&scoped=true&"
import script from "./verificationProduct.vue?vue&type=script&lang=js&"
export * from "./verificationProduct.vue?vue&type=script&lang=js&"
import style0 from "./verificationProduct.vue?vue&type=style&index=0&id=404ad664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ad664",
  null
  
)

export default component.exports